export default __webpack_public_path__ + "images/df2d32c3a611a2df52a2a43e14f7bc80-business.webp";